module.exports = __webpack_public_path__ + "assets/img/icon-zhi-mnp.361cf527.png";